<template>
    <div>
      <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }">
        <template #title>
          <a-row>
            <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
              <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
              <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span class="ml-5 text-danger font-weight-bold">เดินทางไปต่างประเทศ</span>
            </h6>
            <p style="font-size: 10px;" class="font-web mt-5 mb-0 ml-20">&nbsp;&nbsp;Form for requesting permission to travel abroad for personnel</p>
            </a-col>
          </a-row>
        </template>
        <!-- form -->
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
          <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7">
            <historyRequest :dataRequest="dataHistory" textHead="Form for requesting permission to travel abroad for personnel" :loadingList="loadingList" />
          </a-col>
          <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
            <a-form class="font-web" :layout="'horizontal'">
              <a-descriptions bordered title="" layout="vertical" size="small">
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      1. เดินทางไป
                    </h6>
                  </div>
                  <div class="m-30">
                    <h6 class="mt-20 mb-10 font-web">
                      ประเทศที่จะเดินทางไป <span class="text-danger">*</span>
                    </h6>
                    <a-select
                      show-search
                      placeholder="รายชื่อประเทศ"
                      option-filter-prop="children"
                      :show-arrow="false"
                      style="width: 100%"
                      :filter-option="filterOption"
                      @focus="handleFocus"
                      @blur="handleBlur"
                      @change="handleChange"
                      v-model="formTravel.countryMain"
                    >
                      <a-select-option v-for="(litFilter, index) in countryList" :key="'l'+index" :value="litFilter.value">
                        {{ litFilter.text  }}
                      </a-select-option>
                    </a-select>
                    <!-- xxxxxxx -->
                    <h6 class="mt-20 mb-10 font-web">
                      เหตุผลความจำเป็นในการเดินทาง <span class="text-danger">*</span>
                    </h6>
                    <a-form-item>
                      <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formTravel.detail" />
                    </a-form-item>
                    <!-- xxxxxxx -->
                    <h6 class="mt-10 mb-10 font-web">
                      Upload เอกสารประกอบการพิจารณา เช่น หนังสือเชิญประชุม / สัมมนา (ถ้ามี) :
                    </h6>
                    <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
                      v-model="formTravel.file_backup" class="mb-5" accept="image/*;capture=camera">
                      <a-button> <a-icon type="upload" /> Select File </a-button>
                    </a-upload>
                  </div>
                </a-descriptions-item>

                <a-descriptions-item :span="2">
                  <div slot="label" class="text-center">
                    <h6 class="mt-0 mb-0 font-web">
                      2. ออกจากประเทศไทย  <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <div class="mt-30 mb-5 text-center">
                    <a-date-picker v-model="formTravel.selected_date" :disabled-date="disabledWorkDate" format="YYYY-MM-DD"
                      placeholder="Start" :mode="['date']" @openChange="handleStartOpenChange" />
                  </div>
                  <div class="mt-20 mb-10 ml-10 mr-10">
                    <h6 class="mt-0 mb-10 font-web">
                      สายการบิน
                    </h6>
                    <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formTravel.airOut" />
                    <p class="mt-20 mb-10 font-web">
                      กรณีที่มีการแวะเปลี่ยนเครื่อง / Transit (โปรดระบุประเทศ)
                    </p>
                    <a-select
                      show-search
                      placeholder="รายชื่อประเทศ"
                      option-filter-prop="children"
                      :show-arrow="false"
                      style="width: 100%"
                      :filter-option="filterOption"
                      @focus="handleFocus"
                      @blur="handleBlur"
                      @change="handleChange"
                      v-model="formTravel.countryOut"
                      class="mb-10"
                    >
                      <a-select-option v-for="(litFilter, index) in countryList" :key="'l'+index" :value="litFilter.value">
                        {{ litFilter.text  }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-descriptions-item>

                <a-descriptions-item :span="2">
                  <div slot="label" class="text-center">
                    <h6 class="mt-0 mb-0 font-web">
                      3. กลับเข้าประเทศไทย  <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <div class="mt-30 mb-5 text-center">
                    <a-date-picker :mode="['date']" v-model="formTravel.move_to_date" :disabled-date="disabledHolidayDate"
                    format="YYYY-MM-DD" placeholder="End" :open="endOpen" :disabled="formTravel.selected_date === null"
                    @openChange="handleEndOpenChange" />
                  </div>
                  <div class="mt-20 mb-10 ml-10 mr-10">
                    <h6 class="mt-0 mb-10 font-web">
                      สายการบิน
                    </h6>
                    <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formTravel.airIn" />
                    <p class="mt-20 mb-10 font-web">
                      กรณีที่มีการแวะเปลี่ยนเครื่อง / Transit (โปรดระบุประเทศ)
                    </p>
                    <a-select
                      show-search
                      placeholder="รายชื่อประเทศ"
                      option-filter-prop="children"
                      :show-arrow="false"
                      style="width: 100%"
                      :filter-option="filterOption"
                      @focus="handleFocus"
                      @blur="handleBlur"
                      @change="handleChange"
                      v-model="formTravel.countryIn"
                      class="mb-10"
                    >
                      <a-select-option v-for="(litFilter, index) in countryList" :key="'l'+index" :value="litFilter.value">
                        {{ litFilter.text  }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-descriptions-item>

                <a-descriptions-item span="3">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      4. รวมระยะเวลาการเดินทาง
                    </h6>
                  </div>
                  <a-input-number type="number" v-model="formTravel.travel_amount" :disabled="formTravel.selected_date === '' || formTravel.move_to_date === ''
                    " />
                </a-descriptions-item>
              </a-descriptions>
              <br /><br />
              <a-form-item class="mt-3">
                <a-row>
                  <a-col :span="8">
                    <a-button type="danger" @click="clearForm">
                      <b>ยกเลิกการขอ</b>
                    </a-button>
                  </a-col>
                  <a-col :style="{ textAlign: 'right' }" :span="8" :offset="8">
                    <a-button type="primary" class="font-web pa-10" @click="dialogConfirm = true" size="lg"
                      style="font-size: 14px" :disabled="formTravel.selected_date === null ||
                        formTravel.move_to_date === null
                        ">
                      ส่งคำขออนุมัติ
                    </a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
            
          </a-col>
        </a-row>
      </a-card>
      <!-- dialog -->
      <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequest" @cancel="clearForm">
        <p v-if="boxFlexError.length === 0" class="mt-10 mb-20">
          Are you sure to Submit ?
        </p>
        <a-spin v-if="loading" tip="Loading..."></a-spin>
        <div v-if="boxFlexError.length !== 0">
          <a-alert :message="`Error The date you selected cannot be redeemed ::`" type="error" show-icon>
            <div slot="description">
              <span v-if="boxFlexError[0].msg === undefined">
                {{ boxFlexError[0] }}
              </span>
              <span v-else>{{ boxFlexError[0].msg }}</span>
            </div>
          </a-alert>
        </div>
      </a-modal>
    </div>
  </template>
  
  <script>
  const form = {
    selected_date: null,
    move_to_date: null,
    travel_amount: 0,
    detail: "",
    file_backup: null,
    airIn: null,
    airOut: null,
    countryMain: null,
    countryIn: null,
    countryOut: null,
  };
  import countryList from './country';
  import historyRequest from './history_request.vue';
  import { hriRequestMixin } from "@/mixins/hriRequestMixin";
  export default {
    mixins: [hriRequestMixin],
    components: {
      historyRequest
    },
    data() {
      return {
        countryList,
        dialogConfirm: false,
        // form
        formTravel: { ...form },
        loading: false,
        // config
        mode1: "time",
        dataDayNotFlex: [],
        // error
        boxFlexError: [],
        // file upload - handled by mixin
        uploading: false,
        // 
        dataHistory: ['',''],
        loadingList: false,
      };
    },
    computed: {
      dateVal() {
        const { selected_date, move_to_date } = this.formTravel;
        return {
          selected_date,
          move_to_date,
        };
      },
    },
    watch: {
      dateVal: {
        handler(val) {
          this.formTravel.travel_amount = 0;
          if (val.selected_date === "" || val.selected_date === null) {
            this.formTravel.move_to_date = "";
          }
          if (
            val.selected_date !== "" &&
            val.selected_date !== null &&
            val.move_to_date !== "" &&
            val.move_to_date !== null
          ) {
            this.setCalTotalDate(val.selected_date, val.move_to_date);
          }
        },
        deep: true,
      },
    },
    mounted() {
      this.stBudgetYear()
      this.getAllRequest()
    },
    methods: {
      handleChange(value) {
      },
      handleBlur() {
      },
      handleFocus() {
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
    async getAllRequest() {
      await this.loadRequestHistory('/hri/travel-aboard-request/', { start: 'timestart', end: 'timeend' });
    },
      // func. write
      disabledWorkDate(date) {

        return false
      },
      disabledEndDate(endValue) {
        return false;
      },
      disabledHolidayDate(date) {
        return false;
      },
      clearForm() {
        this.dialogConfirm = false;
        this.formTravel = { ...form };
        this.boxFlexError = [];
      },
      setCalTotalDate(a, b) {
        let start = this.moment(a);
        let end = this.moment(b);
        this.formTravel.travel_amount = 0;
        let diff = end.diff(start, "days") + 1;
        this.formTravel.travel_amount = diff;
      },
      async submitRequest() {
        this.boxFlexError = [];
        this.loading = true;
        const sendData = new FormData();
        sendData.append(
          "start_date",
          this.moment(this.formTravel.selected_date).format("YYYY-MM-DD")
        );
        sendData.append(
          "end_date",
          this.moment(this.formTravel.move_to_date).format("YYYY-MM-DD")
        );
    

      },
    },
  };
  </script>
  
  <style scoped>
  .f-14 {
    font-size: 14px;
  }
  
  .spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
  }
  </style>